import React from 'react';
import ReactDOM from 'react-dom';
import OlOverlay from 'ol/Overlay';
import OlMap from 'ol/Map';
import MapBrowserEvent from 'ol/MapBrowserEvent';
import { TooltipProperties } from '../Common/TooltipProperties';
import CctvCameraTooltip from 'Common/Map/OpenLayers/Cctv/CctvCameraTooltip';

interface IProps {
    map: OlMap
}

export default class Tooltip {

    map: OlMap;

    overlay!: OlOverlay;

    activeTooltipId!: string | null;

    constructor({ map }: IProps) {
        this.map = map;
        this.initializeMenu();
    }

    initializeMenu = () => {

        this.overlay = new OlOverlay({
            offset: [10, 0]
        });

        this.map.addOverlay(this.overlay);
        this.map.on('pointermove', this.displayTooltip);
    }

    displayTooltip = (evt: MapBrowserEvent) => {
        let tooltipProperties: TooltipProperties | null = null;

        // if features present, get top most feature.
        this.map.forEachFeatureAtPixel(evt.pixel, ft => {
            let ftTooltipProperties = ft.get("tooltipProperties") as TooltipProperties | null;

            if (ftTooltipProperties != null) {
                tooltipProperties = ftTooltipProperties;
            }
        });

        
        let newTooltipId = tooltipProperties == null ? null : (tooltipProperties as TooltipProperties).id;

        if (this.activeTooltipId != newTooltipId) {

            let element = this.overlay.getElement();
            if (this.overlay && !element) {
                element = document.createElement("div");
                this.overlay.setElement(element);
            }

            if (this.overlay && element && this.activeTooltipId) {
                ReactDOM.unmountComponentAtNode(element);
                element.style.display = 'none';
                this.activeTooltipId = null;
            }

            if (tooltipProperties && element) {
                this.activeTooltipId = (tooltipProperties as TooltipProperties).id;
                let Tooltip = (tooltipProperties as TooltipProperties).element;
                ReactDOM.render(
                    <Tooltip />,
                    element
                )
                element.style.display = 'block';
                this.overlay.setPosition(evt.coordinate);
            }
        }
    }

    cleanup = () => {
        this.map.removeOverlay(this.overlay);
    }
}